import { SemiDonutComponent, SemiDonutProps } from "./SemiDonutComponent"
import { ChartCard, ChartCardProps, UnderSemiDonut, UnderSemiDonutProps } from "../components"

type Props<TData, TLabel> = Omit<ChartCardProps, "legends"> & {
  chart: SemiDonutProps<TData, TLabel>
  underChart: UnderSemiDonutProps
}

export const SemiDonut = <TData = number, TLabel = unknown>({ chart, underChart, ...props }: Props<TData, TLabel>) => {
  const total = chart.data.map((it) => it.value as unknown as number).reduce((acc, cur) => acc + cur, 0)
  return (
    <ChartCard {...props} data={chart.data} total={total}>
      <SemiDonutComponent {...chart} />
      <UnderSemiDonut {...underChart} />
    </ChartCard>
  )
}
